import React, { useState } from 'react';
import { Grid, Typography, Paper, Box } from '@material-ui/core';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Page, Content } from '@backstage/core-components';
import { PerformanceListComponent } from '../PerformanceListComponent/PerformanceListComponent';
import { PerformanceDetailComponent } from '../PerformanceDetailComponent/PerformanceDetailComponent';
import { usePerformanceEntity } from '../../hooks/usePerformanceEntity';
import { useTransactionGroups } from '../../hooks/useTransactionGroups';
import { useTransactionGroupDetail } from '../../hooks/useTransactionGroupDetail';
import { TransactionGroup } from '../../types';

export const PerformanceWrapperComponent = () => {
  const { entity } = useEntity();
  const entityResult = usePerformanceEntity(entity);
  const [selectedTransaction, setSelectedTransaction] = useState<TransactionGroup | null>(null);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);

  // Handle entity parsing errors
  if (!entityResult.success) {
    return (
      <Page themeId="tool">
        <Content>
          <Paper style={{ padding: 16 }}>
            <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
              <Typography variant="h6" color="error" gutterBottom>
                Configuration Error
              </Typography>
              <Typography variant="body1" color="textSecondary" paragraph>
                {entityResult.error}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Please check your entity annotations and try again.
              </Typography>
            </Box>
          </Paper>
        </Content>
      </Page>
    );
  }

  const { host, org, projectId } = entityResult.data;

  const {
    data: transactionGroups,
    isLoading,
    error,
    currentFilters,
    pagination,
    handleFilterChange,
    handleSearch,
    handleDateRangeChange,
    handlePageChange,
    refetch,
  } = useTransactionGroups({ host, org, projectId });

  const {
    data: transactionDetailData,
    isLoading: isDetailLoading,
    error: detailError,
    // refetch: refetchDetail,
  } = useTransactionGroupDetail(
    selectedTransaction ? { host, org, id: selectedTransaction.id.toString() } : null
  );

  const handleTransactionClick = (transaction: TransactionGroup) => {
    setSelectedTransaction(transaction);
    setDetailDialogOpen(true);
  };

  const handleDetailClose = () => {
    setDetailDialogOpen(false);
    setSelectedTransaction(null);
  };

  return (
    <Page themeId="tool">
      <Content>
        <Grid container spacing={3} direction="column">
          <Grid item>
            <PerformanceListComponent
              transactionGroups={transactionGroups}
              isLoading={isLoading}
              error={error}
              currentFilters={currentFilters}
              pagination={pagination}
              onFilterChange={handleFilterChange}
              onSearch={handleSearch}
              onDateRangeChange={handleDateRangeChange}
              onRefresh={refetch}
              onTransactionClick={handleTransactionClick}
              onPageChange={handlePageChange}
              host={host}
              org={org}
              projectId={projectId}
            />
          </Grid>
        </Grid>

        {/* Transaction Detail Dialog */}
        <PerformanceDetailComponent
          data={transactionDetailData}
          isLoading={isDetailLoading}
          error={detailError}
          open={detailDialogOpen}
          onClose={handleDetailClose}
        />
      </Content>
    </Page>
  );
};
